export default __webpack_public_path__ + "static/media/resource-group-example-1-en.37cc499e.png";